import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../../api";
import { BackIcon } from "../../../assets";
import "./technical.css";
import Quiz from "../../../components/quiz";
import { localStoreName } from "../../../utils/constants";
import QuizCompleteModal from "../../../components/quizCompleteModal";

export const Technical = () => {
  const thisYear = new Date().getFullYear();
  const [quizIsExpired, setQuizIsExpired] = useState(null);
  const hasSubmitted = JSON.parse(localStorage.getItem(localStoreName))
    ?.user_quiz?.submitted;

  const [quiz, setQuiz] = useState("");

  useEffect(() => {
    let timer = setInterval(() => {
      const quizStoppageTime = new Date(
        JSON.parse(
          localStorage.getItem(localStoreName)
        )?.technical_test?.ended_at
      );

      const currentDate = new Date();
      if (quizStoppageTime < currentDate) {
        setQuizIsExpired(true);
      } else {
        setQuizIsExpired(false);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const qRef = useRef();

  useEffect(() => {
    if (qRef.current) {
      qRef.current.innerHTML = quiz;
    }
    return () => {};
  }, [qRef, quiz]);

  if (quizIsExpired) {
    return (
      <div style={{ padding: "4rem 3rem", fontSize: "1.2rem" }}>
        <Link to={"/dashboard"}>
          <BackIcon className="my-5" />
        </Link>
        <p>Your time for the technical test has expired.</p>
      </div>
    );
  }

  if (hasSubmitted) {
    return (
      <div style={{ padding: "4rem 3rem", fontSize: "1.2rem" }}>
        <Link to={"/dashboard"}>
          <BackIcon className="my-5" />
        </Link>

        <p>You have already submitted your technical test.</p>
      </div>
    );
  }

  return (
    <div className="mt-5 container">
      <Link to={"/dashboard"}>
        <BackIcon className="my-5" />
      </Link>
      <div className="quizHeader">
        <h2>Technical Test</h2>
        <p>
          Pick one option for each question. Make sure you finish before your
          timer runs out. Good luck!
        </p>
      </div>

      <div>
        <Quiz />
      </div>
    </div>
  );
};
